FAQList =
{
	p_obj_ref : ".faqs-list"
	,
	init : function()
	{
		//Reset all answers to normal
		FAQList.resetAllAnswers();
	
		//Set FAQ links to style appropriate answer.
		jQuery(FAQList.p_obj_ref).not('.static').find(' .question').each( function(pm_index){
			
			jQuery(this).on('click', function(event){
				var my_parent = jQuery(this).closest('li');
				
				if( my_parent.hasClass('active') )
		        {
		          my_parent.find(".answer").slideUp('fast',function(){
			          my_parent.removeClass('active');
		          });
		          //my_parent.removeClass('active');
		        }
		        else
		        {
		          my_parent.find(".answer").slideDown('fast',function(){
			          my_parent.addClass('active');
		          });
		          //my_parent.addClass( "active" );
		        }
			});
		} );
				
		//Set nominating CSS alert.
		jQuery(FAQList.p_obj_ref).not('.static').addClass("expandable initiated");
	}
	,
	//Resets all answer elements to normal. 
	resetAllAnswers : function()
	{
		jQuery(FAQList.p_obj_ref).not('.static').find( "li" ).removeClass( "active" );
		jQuery(FAQList.p_obj_ref).not('.static').find(".answer").hide();
	}
};//end object literal faqList
			
jQuery(document).ready(function(jQuery){
	
	FAQList.init();
	
});
